import React from "react";
import { motion } from "framer-motion";
import { FaEnvelope, FaLinkedin, FaMapMarkerAlt } from "react-icons/fa";
import { sectionVariants } from "../../constants/animations";
import { CONTACT_INFO } from "./Contact.constants";

const Contact: React.FC = () => {
  return (
    <motion.section
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="py-20 px-6"
    >
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-12 gradient-text">
          Get In Touch
        </h2>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="glass rounded-2xl p-8 gradient-border"
        >
          <p className="text-xl text-slate-300 mb-4">
            I'm always open to new opportunities and interesting projects.
          </p>
          <p className="text-slate-400 mb-8">
            Whether you have a question, want to collaborate, or just want to
            say hi, feel free to reach out. I'll try my best to get back to
            you!
          </p>
          <div className="flex flex-col md:flex-row justify-center gap-8 mb-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0 }}
              viewport={{ once: true }}
              className="flex items-center gap-3 justify-center"
            >
              <FaEnvelope className="text-2xl text-blue-400" />
              <div className="text-left">
                <p className="text-xs text-slate-400">Email</p>
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  className="text-white hover:text-blue-400 transition-colors font-medium"
                >
                  {CONTACT_INFO.email}
                </a>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              viewport={{ once: true }}
              className="flex items-center gap-3 justify-center"
            >
              <FaLinkedin className="text-2xl text-blue-400" />
              <div className="text-left">
                <p className="text-xs text-slate-400">LinkedIn</p>
                <a
                  href={CONTACT_INFO.linkedinUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-blue-400 transition-colors font-medium"
                >
                  {CONTACT_INFO.linkedin}
                </a>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              viewport={{ once: true }}
              className="flex items-center gap-3 justify-center"
            >
              <FaMapMarkerAlt className="text-2xl text-blue-400" />
              <div className="text-left">
                <p className="text-xs text-slate-400">Location</p>
                <p className="text-white font-medium">{CONTACT_INFO.location}</p>
              </div>
            </motion.div>
          </div>

          <div className="flex justify-center gap-4">
            <motion.a
              href={`mailto:${CONTACT_INFO.email}`}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-3 rounded-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white font-medium hover:shadow-lg hover:shadow-blue-500/25 transition-shadow"
            >
              Send Message
            </motion.a>
            <motion.a
              href="/resume.pdf"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-3 rounded-full glass text-white font-medium hover:bg-white/10 transition-colors"
            >
              Download CV
            </motion.a>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Contact;
